// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"c508dd34","421":"81a5ac73","670":"aab3d8d9","757":"cb1c6bdf","787":"7bf59442","791":"81a5ac73","967":"aab3d8d9"}[chunkId] + ".chunk.js";
};